/**
 * @desc 生成产品条码pdf
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.plmProductSku.getProductCodePdf.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/getProductCodePdf`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
